if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    /* FAQ */
	let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
        prevArrow: '<button type="button" class="slick-prev">Prev</button>'
    });

    $('.top-reasons__slider').slick({
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 700,
        fade: true,
        prevArrow: '<button type="button" class="slick-prev">Prev</button>',
        asNavFor: '.top-reasons__slider-two'
    });

    $('.top-reasons__slider-two').slick({
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 700,
        fade: true,
        asNavFor: '.top-reasons__slider'
    });

    $('.accommodations__slider').slick({
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        fade: true,
        accessibility: false,
        prevArrow: '<button type="button" class="slick-prev">Prev</button>',
    });

    $('.sym-slider-block').slick({
        arrows: true,
        dots: false,
        accessibility: true,
        adaptiveHeight:true,
        prevArrow: '.prev-arrow',
        nextArrow: ".next-arrow",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true,
                    adaptiveHeight:true,
                }
            }
        ]
    });

    $("a.fancybox").fancybox();

})();